@let wizardHost = wizard();
@let ticketInfo = ticket();
<div class="flex w-full min-w-0 flex-col gap-4">
  <div class="flex w-full min-w-0 flex-col gap-3">
    <h2 class="mx-auto max-w-full px-1 text-center text-base font-bold leading-snug text-[#1a1523]" id="mobile-ticket-summary-page-title">
      {{ "mobile.eachat.wizard.summaryOrderTitle" | translate }}
    </h2>
    <button
      type="button"
      class="mobile-summary-pdf-download-btn mx-auto inline-flex min-h-[44px] max-w-full min-w-0 shrink-0 flex-nowrap items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#6f42c1] px-5 py-2.5 text-sm font-bold leading-none text-white shadow-md transition-opacity active:opacity-90 disabled:opacity-50"
      [disabled]="pdfDownloading()"
      [attr.aria-label]="'mobile.eachat.wizard.summaryDownloadAria' | translate"
      aria-describedby="mobile-ticket-summary-page-title"
      (click)="onDownloadPdf()"
    >
      <span class="relative flex size-[22px] shrink-0 items-center justify-center overflow-hidden leading-none" aria-hidden="true">
        @if (pdfDownloading()) {
          <span class="material-icons block animate-spin select-none text-[20px]">progress_activity</span>
        } @else {
          <span class="material-icons block select-none text-[20px]">download</span>
        }
      </span>
      <span>{{ "mobile.eachat.wizard.summaryDownload" | translate }}</span>
    </button>
  </div>

  <dl class="grid gap-3 text-[0.85rem]">
    <div class="flex justify-between gap-2">
      <dt class="shrink-0 text-[0.7rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">
        {{ "mobile.eachat.field.label" | translate }}
      </dt>
      <dd class="max-w-[65%] text-right font-medium text-[#1a1523]">{{ wizardHost.generalForm.controls["label"].value }}</dd>
    </div>
    <div class="flex justify-between gap-2">
      <dt class="shrink-0 text-[0.7rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">
        {{ "mobile.eachat.field.comment" | translate }}
      </dt>
      <dd class="max-w-[65%] text-right font-medium text-[#7a7583]">
        {{
          wizardHost.generalForm.controls["description"].value.trim()
            ? wizardHost.generalForm.controls["description"].value
            : ("app.shared.notprovided" | translate)
        }}
      </dd>
    </div>
    <div class="flex justify-between gap-2">
      <dt class="shrink-0 text-[0.7rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">
        {{ "mobile.eachat.wizard.summaryActionType" | translate }}
      </dt>
      <dd class="max-w-[65%] truncate text-right font-medium text-[#1a1523]">
        {{ (ticketInfo.TaskCategoryLabel?.trim()) || ("app.shared.notprovided" | translate) }}
      </dd>
    </div>
    <div class="flex justify-between gap-2">
      <dt class="shrink-0 text-[0.7rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">
        {{ "mobile.eachat.field.requester" | translate }}
      </dt>
      <dd class="max-w-[65%] truncate text-right font-medium text-[#1a1523]">
        {{ wizardHost.mobileTicketRequesterLabel(ticketInfo) || ("app.shared.notprovided" | translate) }}
      </dd>
    </div>
    <div class="flex justify-between gap-2">
      <dt class="shrink-0 text-[0.7rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">
        {{ "mobile.eachat.wizard.summaryContactDelivery" | translate }}
      </dt>
      <dd class="max-w-[65%] truncate text-right font-medium text-[#1a1523]">
        {{ wizardHost.mobileTicketRecipientLabel(ticketInfo) || ("app.shared.notprovided" | translate) }}
      </dd>
    </div>
  </dl>

  @if (showLinesSection()) {
    <div class="flex min-w-0 flex-col gap-2">
      <h3 class="text-sm font-semibold text-[#3d2652]">{{ summaryLinesSectionTitleKey() | translate }}</h3>
      @if (wizardHost.deliveryProducts().length === 0) {
        <p class="rounded-xl border border-dashed border-[#ece4f3] px-3 py-4 text-center text-sm text-[#7a6b8a]">
          {{ "mobile.eachat.wizard.summaryEmptyLines" | translate }}
        </p>
      } @else {
        <div class="min-w-0 overflow-x-auto rounded-xl border border-[#ece4f3] bg-white">
          @if (summaryIsArticleTable()) {
            <table class="w-full min-w-[280px] border-collapse text-left text-[0.8rem]">
              <thead>
                <tr class="border-b border-[#ece4f3] bg-[#f5f0fa]">
                  <th class="px-3 py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]">
                    {{ summaryArticlePrimaryColumnKey() | translate }}
                  </th>
                  <th
                    class="w-14 px-2 py-2.5 text-center text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]"
                  >
                    {{ "mobile.eachat.field.quantity" | translate }}
                  </th>
                  <th
                    class="min-w-[4.5rem] px-2 py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]"
                  >
                    {{ "mobile.eachat.wizard.unitLabel" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (deliveryLine of wizardHost.deliveryProducts(); track deliveryLineTrack($index, deliveryLine)) {
                  <tr class="border-b border-[#f0ebf5] last:border-b-0">
                    <td class="px-3 py-3 align-top">
                      <p class="font-semibold text-[#1a1523]">{{ wizardHost.mobileDeliveryProductTitle(deliveryLine) }}</p>
                      @if (wizardHost.mobileDeliveryProductSubtitle(deliveryLine)) {
                        <p class="mt-0.5 font-mono text-[0.7rem] font-medium text-[#6f42c1]">
                          {{ wizardHost.mobileDeliveryProductSubtitle(deliveryLine) }}
                        </p>
                      }
                    </td>
                    <td class="px-2 py-3 text-center tabular-nums text-[#1a1523]">{{ deliveryLine.Quantity }}</td>
                    <td class="px-2 py-3 text-[#1a1523]">{{ deliveryLine.Unit?.Name || "—" }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
          @if (summaryIsEquipmentTable()) {
            <table class="w-full min-w-[280px] border-collapse text-left text-[0.8rem]">
              <thead>
                <tr class="border-b border-[#ece4f3] bg-[#f5f0fa]">
                  <th class="px-3 py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]">
                    {{ "mobile.eachat.wizard.vehicleTableColVehicle" | translate }}
                  </th>
                  <th
                    class="min-w-[5.5rem] px-3 py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]"
                  >
                    {{ "mobile.eachat.wizard.vehicleTableColDesignation" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (deliveryLine of wizardHost.deliveryProducts(); track deliveryLineTrack($index, deliveryLine)) {
                  <tr class="border-b border-[#f0ebf5] last:border-b-0">
                    <td class="px-3 py-3 align-top">
                      <p class="font-semibold text-[#1a1523]">{{ summaryEquipmentPrimaryLine(deliveryLine) }}</p>
                      @if (summaryEquipmentRegistrationLine(deliveryLine)) {
                        <p class="mt-0.5 font-mono text-[0.7rem] text-[#7a6b8a]">
                          {{ summaryEquipmentRegistrationLine(deliveryLine) }}
                        </p>
                      }
                    </td>
                    <td class="px-3 py-3 align-top text-[#1a1523]">{{ summaryEquipmentDesignation(deliveryLine) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
          @if (summaryIsEquipmentTypeTable()) {
            <table class="w-full min-w-[280px] border-collapse text-left text-[0.8rem]">
              <thead>
                <tr class="border-b border-[#ece4f3] bg-[#f5f0fa]">
                  <th class="px-3 py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]">
                    {{ "mobile.eachat.wizard.vehicleTableColType" | translate }}
                  </th>
                  <th
                    class="w-[4.25rem] px-2 py-2.5 text-center text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]"
                  >
                    {{ "mobile.eachat.wizard.vehicleTableColSeats" | translate }}
                  </th>
                  <th class="min-w-[4.5rem] px-3 py-2.5 text-[0.65rem] font-bold uppercase tracking-wide text-[#7a6b8a]">
                    {{ "mobile.eachat.wizard.vehicleTableColEnergy" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (deliveryLine of wizardHost.deliveryProducts(); track deliveryLineTrack($index, deliveryLine)) {
                  <tr class="border-b border-[#f0ebf5] last:border-b-0">
                    <td class="px-3 py-3 font-semibold text-[#1a1523]">{{ summaryEquipmentTypeLabel(deliveryLine) }}</td>
                    <td class="px-2 py-3 text-center tabular-nums text-[#1a1523]">
                      {{ summaryEquipmentTypeSeats(deliveryLine) }}
                    </td>
                    <td class="px-3 py-3 text-[#1a1523]">{{ wizardHost.equipmentLineEnergyLabel(deliveryLine) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      }
    </div>
  }

  <div class="flex min-w-0 gap-3 rounded-xl border border-[#ece4f3] bg-[#faf7fc] p-3">
    <span class="material-icons shrink-0 text-[#5a2f6b]" aria-hidden="true">local_shipping</span>
    <div class="min-w-0 flex-1">
      <p class="text-sm font-semibold text-[#3d2652]">{{ deliveryModeLabel() }}</p>
      <p class="mt-2 flex items-start gap-1.5 text-[0.8rem] text-[#574f66]">
        <span class="material-icons mt-0.5 shrink-0 text-[16px] text-[#7a6b8a]" aria-hidden="true">place</span>
        <span class="min-w-0">{{
          deliveryAddressLine() || ("app.shared.notprovided" | translate)
        }}</span>
      </p>
    </div>
  </div>

  @if (saveHadError()) {
    <p class="text-sm text-destructive">{{ "mobile.eachat.wizard.saveError" | translate }}</p>
  }
</div>
